import { useState, useEffect, useCallback } from "react";
import {
  FaBars,
  FaTimes,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import Logo from "../../assets/image/Logo.webp";
import {
  NavBarCss,
  Menu,
  Link,
  LinkItem,
  MobileMenuButton,
  LogoImage,
  MobileContactInfo,
  ContactItem,
} from "./styles";

const NavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Detectar scroll para alterar estilo da barra de navegação
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Função para alternar o estado do menu mobile
  const toggleMobileMenu = () => setIsMobileMenuOpen((prev) => !prev);

  // Função memoizada para rolar suavemente até uma seção
  const scrollToSection = useCallback((sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -40; // Reduzido de -60 para -40 para parar muito mais próximo do topo
      const targetY =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      const duration = 1000; // Duração em milissegundos
      let startTime: number | null = null;

      const animation = (currentTime: number) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        // Função de easing para movimento mais suave
        const easeInOutCubic = (t: number) =>
          t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

        window.scrollTo(0, startY + distance * easeInOutCubic(progress));

        if (timeElapsed < duration) {
          requestAnimationFrame(animation);
        }
      };

      requestAnimationFrame(animation);
      setIsMobileMenuOpen(false);
    }
  }, []);

  const links = [
    { id: "home", label: "Início" },
    { id: "services", label: "Serviços" },
    { id: "store", label: "Sobre" },
    { id: "form", label: "Solicitar Orçamento" },
    { id: "contact", label: "Contato" },
  ];

  return (
    <NavBarCss isScrolled={isScrolled}>
      <div className="container">
        {/* Logo da aplicação */}
        <LogoImage>
          <img src={Logo} alt="Engenhoso Cell Logo" />
        </LogoImage>

        {/* Botão para abrir/fechar menu mobile */}
        <MobileMenuButton
          onClick={toggleMobileMenu}
          aria-label={isMobileMenuOpen ? "Fechar Menu" : "Abrir Menu"}
          isScrolled={isScrolled}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </MobileMenuButton>

        {/* Menu de navegação */}
        <Menu isOpen={isMobileMenuOpen} isScrolled={isScrolled}>
          <Link>
            {links.map(({ id, label }) => (
              <LinkItem key={id} isScrolled={isScrolled}>
                <a onClick={() => scrollToSection(id)}>{label}</a>
              </LinkItem>
            ))}
          </Link>

          {/* Informações de contato no menu mobile */}
          <MobileContactInfo>
            <ContactItem>
              <FaPhone /> <span>16 98145-1428</span>
            </ContactItem>
            <ContactItem>
              <FaEnvelope /> <span>engenhosocell@gmail.com</span>
            </ContactItem>
            <ContactItem>
              <FaMapMarkerAlt />
              <span>Rua: Ulisses de Paula Garcia, 19 - Cristais Paulista</span>
            </ContactItem>
          </MobileContactInfo>
        </Menu>
      </div>
    </NavBarCss>
  );
};

export default NavBar;
